import React from "react";
import Home from "../components/Home";

const Homepage = () => {
    return (
        <>
            <div className="font-primary">
                <Home/>
            </div>            
        </>
    );
};

export default Homepage